import { render, staticRenderFns } from "./activityReview.vue?vue&type=template&id=558d3a0a"
import script from "./activityReview.vue?vue&type=script&lang=js"
export * from "./activityReview.vue?vue&type=script&lang=js"
import style0 from "./activityReview.vue?vue&type=style&index=0&id=558d3a0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports